type HeaderName = { headerName: string };

export const pageHeadersStrings = {
	COMPANY_SETTINGS_PAGE_HEADER: ({ headerName }: HeaderName) => `${'Company Settings'}: ${headerName}`,
	TEAM_SETTINGS_PAGE_HEADER: ({ headerName }: HeaderName) => `${'Team Settings'} - ${headerName}`,
};

export const companyHeaderTabsStrings = {
	COMPANY_SETTINGS_OVERVIEW_HEADER_TAB: 'Overview',
	COMPANY_SETTINGS_TEAMS_HEADER_TAB: 'Teams',
	COMPANY_SETTINGS_SOURCE_CARDS_HEADER_TAB: 'Source cards',
	COMPANY_SETTINGS_PHYSICAL_CARDS_HEADER_TAB: 'Physical cards',
	COMPANY_SETTINGS_CODING_LISTS_HEADER_TAB: 'Accounting codes',
};

export const teamHeaderTabsStrings = {
	TEAM_SETTINGS_OVERVIEW_HEADER_TAB: 'Overview',
	TEAM_SETTINGS_SOURCE_CARDS_HEADER_TAB: 'Source cards',
	TEAM_SETTINGS_PHYSICAL_CARDS_HEADER_TAB: 'Physical cards',
	TEAM_SETTINGS_PEOPLE_HEADER_TAB: 'People',
	TEAM_SETTINGS_CODING_LISTS_HEADER_TAB: 'Accounting codes',
};

export const companySettingsOverviewStrings = {
	ADD_ADMIN_TITLE: 'Add Admin',
	CANCEL_BUTTON_TEXT: 'Cancel',
	HEADER_BUTTON_NAME: 'Save Changes',
	COMPANY_ADMINS_LABEL: 'Company Admins',
	COMPANY_NAME_LABEL: 'Company name',
	COMPANY_NAME_LENGTH_ERROR: 'Length of company name should not be greater than 40 characters',
	HEADER_TITLE: 'Company Settings',
	ADD_SELECTED_BUTTON_TEXT: 'Add selected',
	ADD_COMPANY_ADMIN_BUTTON: 'Add Company Admin',
	INVITE_ADMIN_BUTTON_TEXT: 'Invite new admin user',
	COMPANY_SETTINGS_SUCCESS: 'Company settings saved.',
	COMPANY_SETTINGS_ERROR: 'There was an error saving the settings',
	INVITE_USER_TEXT: ({ role }) => `${'Invite new'} ${role ? role.label.toLowerCase() : 'user'}`,
	ADD_ADMIN_ASIDE_INFO:
		'You can promote one of the team owners listed below to be a company admin or invite a new user.',
	NO_TEAM_OWNERS_ASIDE_INFO: 'There are no team owners.',
	FEATURE_ENABLE_TRANSACTION_RECEIPT_UPLOAD: 'Enable receipt upload for transactions',
	FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE: 'Enable maximum expiration date for virtual card',
	FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE_ASIDE_TITLE: 'Select duration',
	FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE_INPUT_PLACEHOLDER: 'Select default expiration date range',
	FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE_TAG: 'This setting will only affect the new cards',
	FEATURE_ENABLE_DOMAIN_WHITELISTING: 'Enable email domain whitelisting for invited users',
	FEATURE_ENABLE_DOMAIN_WHITELISTING_BUTTON_NAME: 'Add domain',
	FEATURE_ENABLE_DOMAIN_WHITELISTING_INPUT_PLACEHOLDER: 'Example: timbuktu.com',
	FEATURE_ENABLE_DOMAIN_WHITELISTING_WARNING: 'At least one valid domain is required to be able to invite people',
	FEATURE_PAUSE_VIRTUAL_CARD_CREATION: 'Pause new virtual cards from being issued',
	FEATURE_AMEX_APPROVAL_LIMIT: 'Max Approval Limit Per Virtual Card',
	FEATURE_COMPANY_APPROVAL_LIMIT: 'Company approval limit',
	FEATURE_COMPANY_APPROVAL_LIMIT_LABEL_1: 'Limit can be overwritten at a team and individual approver level',
	FEATURE_COMPANY_APPROVAL_LIMIT_LABEL_2: 'Teams and individual limits will never exceed the company limit',
	FEATURE_ENABLE_COMPANY_PEOPLE_VIEW: 'Enable people view for company admin users',
	FEATURE_ENABLE_GLOBALIZATION: 'Enable globalization option in user aside',
	CONFIRM_ACTION_TITLE: 'Confirm action',
	REMOVE_ADMIN_CONFIRMATION_MESSAGE: ({ name }) =>
		`${'Are you sure you want to remove'} ${name} ${'from being a company administrator?'}`,
	ADD_ADMIN_ERROR: 'There was an error adding the admin, please try again.',
	REMOVE_ADMIN_SUCCESS: 'Company Admin has been removed',
	REMOVE_ADMIN_ERROR: 'There was an error removing the admin, please try again.',
};

export const companySettingsTeamsStrings = {
	HEADER_TITLE: 'Company Settings',
	DOWNLOAD_USER_LIST: 'Download User List',
	CREATE_NEW_TEAM: 'Create Team',
	SAVE_AND_CONTINUE: 'Save and Continue',
	SAVE: 'Save',
	INVITE_PEOPLE_BUTTON: 'Invite More People',
	BACK_BUTTON: 'Back',
	VIEW_TEAM_DETAILS: 'View Team Details',
	PAUSE_CARD_CREATION: 'Pause Card Creation',
	UNPAUSE_CARD_CREATION: 'Unpause Card Creation',
	ACTIVATE_TEAM: 'Activate Team',
	REACTIVATE_TEAM: 'Reactivate Team',
	DE_ACTIVATE_TEAM: 'Deactivate Team',
	NOTIFICATION_MESSAGE:
		'Deactivating a team will cancel all active virtual cards and none of the team members, ' +
		'managers, or owners will be able to access the team. Only you or another company admin can ' +
		'reactivate a team. Are you sure?',
	HSBC_NOTIFICATION_MESSAGE:
		'Deactivating a team will cancel all active virtual cards and none of the team members ' +
		'or team owners will be able to access the team. Only you or another company admin can ' +
		'reactivate a team. Are you sure?',
	CONFIRM_ACTION_TITLE: 'Confirm action',
	YES_BUTTON_TEXT: 'Yes',
	CANCEL_BUTTON_TEXT: 'Cancel',
	WARNING_MESSAGE: 'There was an error saving the settings for your team. Please Try again.',
	FEATURE_ENABLE_MULTI_USE_VIRTUAL_CARDS: 'Enable multi use virtual cards',
	FEATURE_ENABLE_SINGLE_USE_VIRTUAL_CARDS: 'Enable single use virtual cards',
	FEATURE_ENABLE_SUBSCRIPTION_VIRTUAL_CARDS: 'Enable subscription virtual cards',
	FEATURE_AMEX_APPROVAL_LIMIT: 'Max Approval Limit Per Virtual Card',
	FEATURE_TEAM_APPROVAL_LIMIT: 'Team approval limit',
	APPROVAL_LIMIT: 'Approval limit',
	TEAM_NAME_TIP: 'Search by team name',
	CREATE_TEAM_TITLE: 'Create team',
	TEAM_CREATED_BY_NOT_AVAILABLE: 'N/A',
};

export const teamSettingsOverviewStrings = {
	HEADER_TITLE: 'Team Settings',
	HEADER_BUTTON_NAME: 'Save Changes',
	TEAM_NAME_LABEL: 'Team name',
	TEAM_OWNER_LABEL: 'Team Owners',
	TEAM_MANAGER_LABEL: 'Team Managers',
	TEAM_MEMBER_LABEL: 'Team Members',
	CARD_SETTINGS_LABEL: 'Card Settings',
	FEATURE_ENABLE_MULTI_USE_VIRTUAL_CARDS: 'Enable multi use virtual cards',
	FEATURE_ENABLE_SINGLE_USE_VIRTUAL_CARDS: 'Enable single use virtual cards',
	FEATURE_ENABLE_SUBSCRIPTION_VIRTUAL_CARDS: 'Enable subscription virtual cards',
	FEATURE_AMEX_APPROVAL_LIMIT: 'MAX APPROVAL LIMIT PER VIRTUAL CARD',
	FEATURE_TEAM_APPROVAL_LIMIT: 'TEAM APPROVAL LIMIT',
	ERROR_AMEX_EXCEEDED_AMOUNT: 'This amount exceeds the Max Approval Limit Per Virtual Card.',
	ERROR_EXCEEDED_AMOUNT: 'This amount exceeds the compnay approval limit.',
	ERROR_INVALID_FORMAT: 'Please enter a positive integer or leave empty.',
	HSBC_ERROR_INVALID_FORMAT: 'Please enter a positive number or leave empty.',
	ERROR_CARD_OPTIONS: 'At least one card option should be enabled.',
	HSBC_ERROR_CARD_OPTIONS: 'At least one card option should be selected.',
	CONFIRM_ACTION_TITLE: 'Confirm action',
	CONFIRM_MULTI_USE_ACTION_CONTENT:
		'Disabling multi-use cards will only impact new multi-use cards from being created. Existing multi-use cards will not be affected',
	CONFIRM_SINGLE_USE_ACTION_CONTENT:
		'Disabling single-use cards will only impact new single-use cards from being created. Existing single-use cards will not be affected.',
	CONFIRM_SUBSCRIPTION_ACTION_CONTENT:
		'Disabling subscriptions cards will only impact new subscriptions cards from being created. Existing subscriptions cards will not be affected.',
	SAVE_TEAM_SUCCESS_MESSAGE: 'Settings saved',
	SAVE_TEAM_WARNING_MESSAGE: 'There has been a problem saving the team settings. Please try again.',
};

export const inputStrings = {
	CARD_HOLDER: 'Card Holder',
	FIRST_NAME: 'First Name',
	LAST_NAME: 'Last Name',
	EMAIL: 'Email',
	CARD_DETAILS: 'Card Details',
	CARD_NAME: 'Card Name',
	CARD_NAME_PLACEHOLDER: 'A friendly nickname, e.g. Marketing Card',
	CARD_NUMBER: 'Card Number',
	EXP_MONTH: 'Expiration Month',
	EXP_MONTH_PLACEHOLDER: 'Select a month',
	EXP_YEAR: 'Expiration Year',
	EXP_YEAR_PLACEHOLDER: 'Select a year',
	BILL_ADDRESS: 'Billing Address',
	STREET_ADDRESS: 'Street Address',
	CITY: 'City',
	COUNTRY: 'Country',
	STATE: 'State',
	STATE_PLACEHOLDER: 'Select a state',
	ZIP_CODE: 'Zip code',
	POST_CODE: 'Postcode',
	SUBMIT: 'Submit',
	CANCEL: 'Cancel',
	ROLE: 'Role',
	ROLE_PLACEHOLDER: 'Select a role',
	ENABLE_SELF_APPROVAL: 'Enable self-approval',
	APPROVER: 'Approver',
	APPROVER_PLACEHOLDER: 'Select a approver',
	SEND_INVITATION: 'Send Invitation',
	SUBMIT_SUCCESS: 'Card name updated.',
	SUBMIT_ERROR: 'There was a problem updating the card name. Please try again.',
};

export const invitePeopleStrings = {
	APPROVER_MESSAGE: 'This team must have an admin or manager before you can invite a member.',
	SUCCESS_MESSAGE: ({ teamId, firstName, lastName }) =>
		`${firstName} ${lastName} ${'was successfully invited'}${teamId ? '.' : ' to the team.'}`,
	SELF_APPROVER_LABEL: 'Self',
	INVITE_USER_TITLE: (user: string) => `Invite new ${user?.toLowerCase() || 'user'}`,
	INVITE_NEW_USER: 'Invite new user',
};

export const navigationStrings = {
	TEAM_INFO: 'Team Information',
	ADD_PEOPLE: 'Add People',
	CODING_LISTS: 'Coding Lists',
};

export const peopleTableStrings = {
	NAME: 'Name',
	NAME_TIP: 'Search by name',
	ROLE: 'Role',
	DEFAULT_APPROVER: 'Default Approver',
	STATUS: 'Status',
	WARNING_MESSAGE: 'There was a problem loading this teams users. Please try again.',
	APPROVER_WARNING_MESSAGE: (fullName: string) =>
		`${fullName} ${'is responsible for approving requests from other team members. Please assign a new approver to the impacted members to proceed.'}`,
	ONLY_USER_WARNING_MESSAGE: (fullName: string) =>
		`${fullName} ${'is the only user in the team, cannot be a team member'}`,
	SUCCESS_MESSAGE: ({ fname }) => `${fname} ${'was removed'}`,
	USER_REMOVE_ERROR_MESSAGE:
		'There was an error removing the user. Please make sure that the user is not an approver for other users on the team and has no pending requests, and that there is at least one other approver on the team.',
	ASIDE_TITLE: 'Select A Role',
};

export const notificationStrings = {
	SUCCESS: 'success',
	WARNING: 'warning',
	ERROR: 'error',
	INFO: 'info',
} as const;

export const messageStrings = {
	EMPTY_LIST_MESSAGE: 'There are no team owners or managers to be selected.',
	WARNING_MESSAGE:
		'Your team has reached the maximum number of members (180). Please create a new team to invite additional members.',
	UNIQUE_TEAM_NAME_ERROR_MESSAGE: 'A team with this name already exists.',
	TEAM_NAME_NOT_EMPTY: 'The team name can not be empty.',
	ERROR_MESSAGE: 'There was an error please try again.',
	SAVE_TEAM_ERROR_MESSAGE: 'Something went wrong. Please try again.',
	CARD_PROVIDER_WARNING_MESSAGE:
		'Your bank returned an error while adding this card. Please contact your bank to resolve and try again.',
	CARD_WARNING_ERROR: 'There was a problem adding the credit card. Please try again.',
	CREDIT_CARD_SUCCESS_MESSAGE: 'Credit card added.',
};

export const validationStrings = {
	REQUIRED_FIELD_ERROR: 'This field is required',
};

export const userDetailsStrings = {
	NO_REQUEST_LIMIT_TEAM_TEXT: 'If no value then team limit applies',
	NO_REQUEST_LIMIT_COMPANY_TEXT: 'If no value then company limit applies',
	REQUEST_LIMIT_VALIDATION_TEXT: maxRequestLimit => `${'Should be less than or equal to'} ${maxRequestLimit}`,
	ACTIVE_CARD_USERS_ERROR: "Users with active cards can't be removed. Please cancel cards to remove this user.",
	PENDING_REQUEST_ERROR: "Can't remove user with pending requests.",
	NO_TEAM_OWNER_AND_MANAGER_ERROR: "Can't remove this user. You need at least one team owner or manager on a team.",
	HSBC_NOT_REMOVE_USER_ERROR_START:
		'Sorry, we are not able to remove this user. This could be due to the following reasons, please ensure:',
	HSBC_NOT_REMOVE_USER_ERROR_BULLETS: [
		'there are no virtual cards linked to this user',
		'they don’t have pending virtual card requests',
		'they aren’t an approver for another user; and / or',
		'they are not the sole approver for this team.',
	],
	HSBC_NOT_REMOVE_USER_ERROR_END: 'Please check and try again.',
	USER_REQUESTERS_ERROR: ({ firstName }) =>
		`${firstName} ${'is responsible for approving requests from other team members. Please assign a new approver to the impacted members to proceed.'}`,
	REMOVE_USER_WARNING: ({ firstName }) =>
		`${'Are you sure you want to remove from the team the following user'}: ${firstName}?`,
};

export const addPeopleStrings = {
	ADD_PEOPLE_HEADER_TITLE: 'Add some people to this team',
	ADD_PEOPLE_HEADER_SUBTITLE_AMEX: 'People in a team can have 3 different roles',
	ADD_PEOPLE_HEADER_SUBTITLE_HSBC: 'People in a team can have 2 different roles',
	TEAM_OWNERS_TEXT: 'Team owners',
	TEAM_OWNER_DESC:
		'Can view all requests and spend activity in the team. Team owners also get a team dashboard to track spend and team wallet where they can see all active cards.',
	MANAGERS_TEXT: 'Managers',
	MANAGERS_DESC:
		'Can approve requests and create cards for members they manage. Managers have a dashboard to track spend for members they manage.',
	MEMBERS_TEXT: 'Members',
	MEMBERS_DESC:
		'Can Request cards and have a wallet for all their cards. Each member gets a default approver (manager) for their requests.',
	INVITE_PEOPLE_TEXT: 'Invite People',
};

export const teamInfoStrings = {
	INVALID_NUMBER_TEXT: 'Please enter a positive integer or leave empty.',
	HSBC_INVALID_NUMBER_TEXT: 'Please enter a positive number or leave empty.',
	EXCEEDS_COMPANY_LIMIT_TEXT: 'This amount exceeds the company approval limit.',
	EXCEEDS_TEAM_LIMIT_TEXT: 'This amount exceeds the team approval limit.',
	EXCEEDS_AMEX_APPROVAL_LIMIT_TEXT: 'This amount exceeds the Max Approval Limit Per Virtual Card.',
	SELECT_CARD_TEXT: 'Select Card',
	ENROLL_SOURCE_CARD: 'Enroll Source Card',
	ENROLL_PHYSICAL_CARD: 'Enroll Physical Card',
	ENROLL_CARD_MESSAGE: 'Enroll your first corporate card to GO.',
	BASIC_SETTINGS_TEXT: 'Basic settings',
	TEAM_NAME: 'Team Name',
	TEAM_NAME_PLACEHOLDER: 'Enter a unique team name',
	VIRTUAL_CARD_OPTIONS_TEXT: 'Virtual card options',
	CREATED_TEXT: 'Created',
	CREATED_BY_TEXT: 'Created By',
	ACTIVE_CARDS_TEXT: 'Active Cards',
	MEMBERS_TEXT: 'Members',
};

export const companySettingsCodingStrings = {
	CODING_LIST: 'Coding list',
	CODING_LIST_PUBLISHED: 'Published',
	PROVIDER_MAPPING: 'Provider mapping',
	UNIQUE_IDENTIFIER_COLUMN: 'Unique identifier',
	CODING_ENTRY_COLUMN: 'Coding entry',
	CODING_ENTRY_SAVE_SUCCESS: 'Coding entry saved.',
	CODING_ENTRY_SAVE_ERROR: 'Sorry, there was a problem saving the coding entry. Please try again.',
	CODING_ENTRY_DUPLICATE_ERROR: ({ entryId }) => `A coding entry with ID '${entryId}' already exists.`,
	TEAMS_WHO_SEE_THIS_COLUMN: 'Teams who see this',
	UNIQUE_IDENTIFIER_PLACEHOLDER: 'Enter a numeric id',
	CODING_ENTRY_PLACEHOLDER: 'Enter new entry',
	REMOVE_ENTRY_CONFIRMATION_ASIDE_TITLE: 'Confirm action',
	REMOVE_ENTRY_CONFIRMATION_ASIDE_NOTE: ({ codingListEntryId, codingListEntryCode }) =>
		`${'Delete coding ID:'} ${codingListEntryId}, ${'Entry:'} ${codingListEntryCode}`,
	REMOVE_LIST_CONFIRMATION_ASIDE_TITLE: 'Remove list',
	REMOVE_LIST_CONFIRMATION_ASIDE_NOTE:
		'Removing a list removes it from being used and ' +
		'deletes all existing entries. If you want to temporarily remove a list and keep the entries you can turn off ' +
		'the publish setting. Are you sure want to remove this list?',
	CHANGE_TEAM_ASIDE_TITLE: 'Select teams',
	CHANGE_TEAM_ASIDE_ALL_TEAMS_OPTION: 'All teams',
	CHANGE_TEAM_ASIDE_SAVE_BUTTON: 'Save',
	CREATE_NEW_LIST_BUTTON: 'Create new list',
	CREATE_NEW_LIST_ASIDE_TITLE: 'Add coding list',
	CREATE_NEW_LIST_ASIDE_NOTE: 'Select from coding list ' + 'presets or create your own new list.',
	CREATE_NEW_LIST_ASIDE_CUSTOM_CODING_BUTTON: 'Create custom list',
	CREATE_NEW_CUSTOM_LIST_ASIDE_TITLE: 'Create custom list',
	CREATE_NEW_CUSTOM_LIST_INPUT_LABEL: 'Custom list name',
	CREATE_NEW_CUSTOM_LIST_BUTTON: 'Add list',
	CREATE_NEW_CUSTOM_LIST_CANCEL_BUTTON: 'Cancel',
	REMOVE_LIST_BUTTON: 'Remove list',
	RENAME_LIST_BUTTON: 'Rename list',
	RENAME_LIST_ASIDE_TITLE: 'Edit custom list',
	RENAME_LIST_INPUT_LABEL: 'Custom list name',
	RENAME_LIST_INPUT_BUTTON: 'Rename coding list',
	RENAME_LIST_INPUT_CANCEL_BUTTON: 'Cancel',
	NO_CODING_LIST_PANEL_HEADER: 'Accounting Codes',
	NO_CODING_LIST_PANEL_PARAGRAPH:
		'Accounting codes are managed through coding ' +
		"lists and entries in lists. You currently haven't created any coding lists. Coding lists can be created " +
		'at the company level and entries in lists can be made specific to teams as needed.',
	NO_CODING_LIST_BUTTON: 'Add coding list',
	NO_CODING_TEXT: 'You don’t have any accounting codes created for this account.',
	NO_CODING_SUB_TEXT: 'You can create accounting codes in company settings.',
	CODING_ENTRY_DELETE_MESSAGE: 'Coding entry deleted',
};

export const companySettingsCardStrings = {
	HEADER_TITLE: 'Company Settings',
	TABLE_ID: 'CardsTable',
	ENROLL_NEW_CARD: 'Enroll card',
};

export const teamSettingsCardStrings = {
	TABLE_ID: 'CardsTable',
	ADD_SOURCE_CARD: 'Add source card',
	ADD_PHYSICAL_CARD: 'Add physical card',
};

export const teamSettingsPeopleStrings = {
	INVITE_PEOPLE: 'Invite People',
};
export const enrollSourceCardStrings = {
	CARD_HEADER_TEXT: 'Enroll source card',
	CARD_HEADER_TEXT_HSBC: 'Enroll physical card',
	SUBMIT_BUTTON_TEXT: 'Submit',
	CARD_HOLDER_FIELD_TEXT: 'Card holder',
	FIRST_NAME_FIELD_TEXT: 'First name',
	LAST_NAME_FIELD_TEXT: 'Last name',
	EMAIL_FIELD_TEXT: 'Email',
	CARD_DETAILS_FIELD_TEXT: 'Card details',
	CARD_NAME_FIELD_TEXT: 'Card name',
	CARD_NAME_PLACEHOLDER_TEXT: 'A friendly nickname, e.g. Marketing Card',
	CARD_NUMBER_PLACEHOLDER_TEXT: 'XXXX XXXXXX XXXXX',
	CARD_NUMBER_FIELD_TEXT: 'Card number',
	EXP_MONTH_FIELD_TEXT: 'Expiration Month',
	EXP_MONTH_PLACEHOLDER_TEXT: 'Select a month',
	EXP_YEAR_FIELD_TEXT: 'Expiration Year',
	SELECT_YEAR_TEXT: 'Select a year',
	BILLING_ADDRESS_FIELD_TEXT: 'Billing address',
	STREET_ADDRESS_FIELD_TEXT: 'Street address',
	CITY_FIELD_TEXT: 'City',
	STATE_FIELD_TEXT: 'State',
	STATE_PLACEHOLDER_TEXT: 'Select a state',
	ZIPCODE_FIELD_TEXT: 'Zip code',
};

export const cardDetailStrings = {
	CARD_DETAILS_ASIDE_TITLE_TEXT: 'Card details',
	SAVE_BUTTON_TEXT: 'Save',
	CARD_NAME_FIELD_TEXT: 'Card name',
	TEAMS_USING_CARD_TEXT: 'Teams using the card',
	REMOVE_SOURCE_CARD_INFO_TEXT: 'Removing a source card from a team will not disable existing virtual cards.',
	REMOVE_PHYSICAL_CARD_INFO_TEXT: 'Removing a physical card from a team will not disable existing virtual cards.',
	ADDITIONAL_CARD_DETAILS_TEXT: 'Additional card details',
	CARDHOLDER_NAME_FIELD_TEXT: 'Cardholder name',
	LAST_4_DIGITS_FIELD_TEXT: 'Last 4 digits',
	CURRENCY_FIELD_TEXT: 'Currency',
	BILLING_ADDRESS_FIELD_TEXT: 'Billing address',
	REMOVE_FROM_TEAM_BUTTON_TEXT: 'Remove from team',
	REMOVE_CARD_ASIDE_TITLE_TEXT: 'Remove Card',
	ALL_TEAMS_LABEL_TEXT: 'All teams',
	APPLY_BUTTON_TEXT: 'Apply',
	SELECT_TEAMS: 'Select teams',
	SELECT_TEAMS_SUBMIT_SUCCESS: 'Teams updated.',
	SELECT_TEAMS_SUBMIT_ERROR: 'There was a problem updating the teams. Please try again.',
	CANT_REMOVE_CARD:
		'You can not remove the only source card linked to this team. Add another card in order to remove this one.',
	HSBC_CANT_REMOVE_CARD:
		"You can't remove the only physical card linked to this team. Add another card in order to remove this one.",
	REMOVE_CARD:
		'Removing a source card from a team will not disable existing virtual cards. Are you ' +
		'sure you want to remove this card from this team?',
	HSBC_REMOVE_CARD:
		'Removing a physical card from a team will not disable existing virtual cards. Are you ' +
		'sure you want to remove this card from this team?',
	REMOVE_CARD_SUCCESS: 'This source card was removed from the team.',
	HSBC_REMOVE_CARD_SUCCESS: 'This physical card was removed from the team.',
	REMOVE_CARD_ERROR: 'There was a problem removing the source card from the team. Please try again.',
	INVALID_CARD_NUMBER: 'Please enter a valid card number.',
	INVALID_EMAIL_FORMAT: 'Please enter a valid email address.',
	REGION_REQUIRED: 'Please enter a valid country.',
	INVALID_REGION_FORMAT: 'Country is required.',
	MIN_REGION_LENGTH: 'The Country must be at least 2 characters long.',
	MAX_REGION_LENGTH: 'The Country must not be more than 27 characters long.',
	INVALID_EMAIL_VALIDATION_BY_PROVIDER: "Email address cannot include the '+' character.",
	DUPLICATE_CARD_ERROR: ({ cardName }) => `A card name with '${cardName}' already exists.`,
	INVALID_ENTRY_WARNING: ({ field }) => `Enter a valid ${field}.`,
	ADD_NEW_CARD_TEXT: 'Add new card',
	ADD_CARD_SOURCE_INSTRUCTIONS_TEXT: 'Link one of these source cards to this team or enroll a new one.',
	HSBC_ADD_CARD_SOURCE_INSTRUCTIONS_TEXT: 'Link one of these physical cards to this team or enroll a new one.',
	ENROLL_NEW_CARD_BUTTON_TEXT: 'Enroll a new card',
	CANCEL_BUTTON_TEXT: 'Cancel',
	CREDIT_CARD_LINK_SUCCESS_MESSAGE: 'This source card has been added to the team.',
	HSBC_CREDIT_CARD_LINK_SUCCESS_MESSAGE: 'This physical card has been added to the team.',
	CREDIT_CARD_LINK_ERROR_MESSAGE: 'There was a problem adding the source card to the team. Please try again',
	YES_BUTTON_TEXT: 'Yes',
};

export const sideMenuStrings = {
	SIDE_MENU_DASHBOARD_OPTION: 'Dashboard',
	SIDE_MENU_APPROVALS_OPTION: 'Approvals',
	SIDE_MENU_WALLET_OPTION: 'Wallet',
	SIDE_MENU_MY_REQUESTS_OPTION: 'My Requests',
	SIDE_MENU_TEAM_SWITCHER_OPTION: 'Team Switcher',
	SIDE_MENU_MANAGE_SETTLEMENTS_OPTION: 'Manage Settlements',
	SIDE_MENU_MANAGE_TRANSACTIONS_OPTION: 'Manage Transactions',
	SIDE_MENU_TEAM_SETTINGS_OPTION: 'Team Settings',
	SIDE_MENU_COMPANY_SETTINGS_OPTION: 'Company Settings',
	SIDE_MENU_SUPPORT_SETTINGS_OPTION: 'Support Settings',
	SIDE_MENU_CREATE_NEW_REQUEST_BUTTON: 'Create New Request',
	SWITCH_TEAM_ERROR_MESSAGE: "We're unable to switch team at this time. Please try again later.",
	SUPPORT: 'Support',
};

export const sessionStrings = {
	ENTER_YOUR_AUTH_APP_CODE_HSBC: 'Enter a code from your authentication app',
	ENTER_YOUR_AUTH_APP_CODE_AMEX: 'Enter your authenticator app code',
	CONTINUE: 'Continue',
	CONFIRM_PASSWORD: 'Confirm Password',
};

export const sessionUserDetailsStrings = {
	INVALID_IMAGE_FILE_FORMAT: 'Please select an image file.',
	PROFILE_PIC_INPUT_LABEL_TEXT: 'Profile picture',
	FIRST_NAME_INPUT_LABEL_TEXT: 'First name',
	LAST_NAME_INPUT_LABEL_TEXT: 'Last name',
	EMAIL_INPUT_LABEL_TEXT: 'Email',
	PHONE_INPUT_LABEL_TEXT: 'Phone number',
	COMPANY_INPUT_LABEL_TEXT: 'Company',
	TEAM_INPUT_LABEL_TEXT: 'Team',
	ROLE_INPUT_LABEL_TEXT: 'Role',
	LANGUAGE_INPUT_LABEL_TEXT: 'Language',
	SAVE_BUTTON_TEXT: 'Save',
	REMOVE_FROM_TEAM_TEXT: 'Remove from Team',
	CANCEL_BUTTON_TEXT: 'Cancel',
	OUT_OF_OFFICE_BUTTON_TEXT: 'Out Of Office',
	SAVE_ERROR_MESSAGE: 'There was a problem saving the profile. Please try again.',
	SAVE_AVATAR_ERROR_MESSAGE: 'There was a problem saving the avatar. Please try again.',
	SAVE_SUCCESS_MESSAGE: 'Profile saved!',
};

export const approvalsStrings = {
	FORWARD_REQUEST: 'Forward request',
	SELECT_APPROVER: 'Select Approver',
	APPROVER_PLACEHOLDER: 'Select a user to forward the request to',
	REASON: 'Reason',
	REASON_PLACEHOLDER: 'The reason will be visible to the approver and the requester',
	FORWARD_BUTTON: 'Forward',
	FWD_CANCEL_BUTTON: 'Cancel',
	REASSIGN_MESSAGE: 'Are you sure you want to re-assign this request back to you?',
	VIEW_ALL_APPROVALS_TEXT: 'View All Approvals',
	NO_APPROVERS_TEXT: 'You can only forward the request to another team owner.',
};

export const walletStrings = {
	BILLING_ADDRESS: 'Billing address',
	CARD_NAME: 'Card name',
	BUSINESS_JUSTIFICATION: 'Business justification',
	VIEW_CARD_ACTIVITY_BUTTON: 'View Card Activity',
	VIEW_CONVERSATION_BUTTON: 'View Conversation',
	CARDHOLDER_NAME_FIELD_TEXT: 'Cardholder name',
	LAST_4_DIGITS_FIELD_TEXT: 'Last 4 digits',
	EXPIRY_DATE_FIELD_TEXT: 'Expiry date',
	ISSUED_ON_FIELD_TEXT: 'Issued on',
	APPROVED_BY_FIELD_TEXT: 'Approved by',
	SOURCE_CARD_NAME_FIELD_TEXT: 'Source card name',
	HSBC_PHYSICAL_CARD_NAME_FIELD_TEXT: 'Physical card name',
	VIRTUAL_CARD_END_DATE: 'Virtual card end date',
	VIRTUAL_CARD_CAN_BE_USED_UNTIL: 'Virtual card can be used until',
	CANCEL_CARD_BUTTON: 'Cancel card',
	CANCEL_CARD_SUCCESS: 'The card was cancelled.',
	CANCEL_CARD_ERROR: 'Could not cancel the card!',
	VIEW_REQUEST: 'View Request',
	CANCEL_CARD_MESSAGE_TEXT:
		'Cancelling this card will not reverse any pending charges. Please look for the settlement records for those charges in the credit card statement sent by your card provider. Are you sure you want to cancel?',
	HSBC_CANCEL_CARD_MESSAGE_TEXT:
		'Please check your credit card statement to review your transactions. Are you sure you want to cancel?',
	USE_THIS_CARD_BUTTON: 'Use this card',
	SETTLEMENT_INFO_TEXT: 'Settlement amount could be different if tips or other fees are applied to the purchase',
	TRANSACTION_INFO_TEXT:
		'Transaction amounts do not include fees, these are available on Business Internet Banking and your physical card statement',
	SETTLEMENT_TITLE_TEXT: 'Settlements',
	TRANSACTIONS_TITLE_TEXT: 'Transactions',
	NO_SETTLEMENT_TEXT: 'No settlements have been posted yet.',
	NO_TRANSACTIONS_TEXT: 'No transactions have been posted yet.',
	VIEW_RECEIPT_TEXT: 'View Receipt',
	REMOVE_RECEIPT_TEXT: 'Remove Receipt',
	UPLOAD_RECEIPT_TEXT: 'Upload Receipt',
	RECEIPT_UPLOAD_SUCCESS: 'Receipt attached',
	RECEIPT_UPLOAD_ERROR: 'Upload failed, try again.',
	RECEIPT_REMOVED_SUCCESS: 'Receipt removed',
	RECEIPT_REMOVED_ERROR: 'Remove receipt failed, try again.',
	MAXIMUM_CHARS: 'You have entered the maximum allowed characters!',
	HSBC_MAXIMUM_CHARS: 'You have entered the maximum number of allowed characters.',
};

export const SupportSettingsStrings = {
	GO_VERSION_TEXT: 'Go Version',
	REQUEST_PROFILE_TEXT: 'Request Profile',
	PROVIDER_API_MAPPING_TEXT: 'Provider API Mapping',
	WORKFLOW_CONFIG_TEXT: 'Workflow Config',
	OUT_OF_OFFICE_TEXT: 'Out-of-Office',
	ACTIVITY_TEXT: 'Activity',
	OOO_TOGGLE_TEXT: 'Enable automatic forwarding of approval requests',
	ACTIVITY_TOGGLE_TEXT: 'Enable activity menu option for company admins',
	READ_LINK_BUTTON: 'Read link',
	SET_LINK_BUTTON: 'Set link',
	CLEAR_LINK_BUTTON: 'Clear link',
	LINK_GO_BRANCH: 'Link Go Branch',
	MASTER_BRANCH_ID_PLACEHOLDER: 'Master Branch id',
	GO_BRANCH_ID_PLACEHOLDER: 'GO Branch id',
	REQUEST_ID_PLACEHOLDER: 'Request id',
	FORCE_CLOSE_STUCK_APPROVAL: 'Force Close Stuck Approval',
	USE_WITH_CAUTION_TEXT: `USE WITH CAUTION! This is a workaround for approvals that are stuck in pending state. Could lead
						to data inconsistency and use it as a last standing option to close an approval, by providing
						the request id in the input above.
						Will delete the approval if there is no virtual card created, and otherwise will complete
						the approval if there is a virtual card created.`,
	CLOSE_APPROVAL_BUTTON: 'Close Approval',
};

export const dashboardStrings = {
	COMPANY_DASHBOARD: 'Company Dashboard',
	SPEND_DASHBOARD: 'Spend Dashboard',
	OVERVIEW: 'Overview (Active cards only)',
	SPEND_OVER_TIME: 'Spend Over Time',
	TEAMS: 'Teams (Active cards only)',
	TEAM_MEMBERS: 'Team Members (Active cards only)',
	ACTIVE_CARDS: 'Active Cards',
	ACTIVE_VIRTUAL_CARDS: 'Active Virtual Cards',
	AVAILABLE_BALANCE: 'Available Balance',
	APPROVED_AMOUNT: 'Approved Amount',
	SPENT_AMOUNT: 'Spent Amount',
	NO_DATA: 'No data to display',
	TEAM_DASHBOARD: 'Team Dashboard',
	TEAM_SETTINGS: 'Team Settings',
	TEAM_FIELD: 'Team',
	MEMBER_FIELD: 'Members',
	ACTIVE_CARDS_FIELD: 'Active Cards',
	APPROVED_FIELD: 'Approved',
	SPENT_FIELD: 'Spent',
	AVALIABLE_FIELD: 'Available',
	TOTAL_SPENT: 'Total Spent',
	NUMBER_OF_TRANSACTIONS: '# of transactions',
};

export const cardUserStrings = {
	PAGE_TITLE: 'Create card user',
	CANCEL_BUTTON: 'Cancel',
	SUBMIT_BUTTON: 'Save',
	SECTION_PERSONAL: 'Personal information',
	SECTION_CONTACT: 'Contact details',
	SECTION_ADDRESS: 'Residential address',
	SECTION_CONSENT: 'Consent',
	FIRST_NAME_LABEL: 'First name',
	FIRST_NAME_HELPER: 'Up to 40 characters',
	LAST_NAME_LABEL: 'Last name',
	LAST_NAME_HELPER: 'Up to 40 characters',
	DATE_OF_BIRTH_LABEL: 'Date of birth',
	DATE_OF_BIRTH_HELPER: 'YYYY-MM-DD',
	EMAIL_LABEL: 'Email address',
	PHONE_COUNTRY_CODE_LABEL: 'Country code',
	PHONE_NUMBER_LABEL: 'Phone number',
	LINE1_LABEL: 'Street address',
	LINE1_HELPER: 'No PO boxes',
	LINE2_LABEL: 'Apartment, suite, etc. (optional)',
	LINE2_TOGGLE: 'Add apartment, suite, or floor',
	CITY_LABEL: 'City',
	STATE_LABEL: 'State',
	POSTAL_CODE_LABEL: 'Zip code',
	COUNTRY_LABEL: 'Country code',
	COUNTRY_HELPER: 'ISO 3166-1 alpha-2, e.g. US',
	CONSENT_LABEL: 'I consent to this data being shared with American Express for verification.',
	REQUIRED: 'This field is required',
	FIRST_NAME_TOO_LONG: 'First name must be 40 characters or fewer',
	LAST_NAME_TOO_LONG: 'Last name must be 40 characters or fewer',
	DOB_INVALID: 'Enter a valid date in YYYY-MM-DD format',
	DOB_FUTURE: 'Date of birth cannot be in the future',
	DOB_TOO_OLD: 'Date of birth cannot be more than 80 years ago',
	EMAIL_INVALID: 'Enter a valid email address',
	PHONE_INVALID: 'Enter a valid mobile phone number',
	LINE1_TOO_LONG: 'Street address must be 40 characters or fewer',
	LINE2_TOO_LONG: 'Apartment/suite must be 256 characters or fewer',
	LINE1_PO_BOX: 'PO boxes are not accepted',
	CITY_INVALID: 'Enter a valid city name (up to 25 characters)',
	STATE_INVALID: 'Enter a valid 2-letter US state code',
	POSTAL_INVALID: 'Enter a valid zip code',
	COUNTRY_INVALID: 'Enter a valid ISO 3166-1 alpha-2 country code',
	CREATE_CARD_USER_SUCCESS: 'Card user created successfully',
};

export const errorStrings = {
	DEFAULT: 'Sorry, we are having technical difficulties. Please try again later.',
	HSBC_PAGE_NOT_FOUND_HEADER: 'Page not found (404)',
	HSBC_PAGE_NOT_FOUND_DESCRIPTION:
		"We are sorry, that page can't be found. The page may have been moved or deleted. Please try finding the new page from the homepage navigation.",
	HSBC_PAGE_NOT_FOUND_BUTTON: 'Go to homepage',
	AMEX_CARD_CREATION:
		"New virtual cards can't be created at this time. Please contact your program administrator for more details.",
	HSBC_CARD_CREATION:
		"New virtual cards can't be created at this time. Please contact your administrator for more details.",
};
